// Generated from GrouperFormula.g4 by ANTLR 4.9
// jshint ignore: start
import antlr4 from 'antlr4';

// This class defines a complete generic visitor for a parse tree produced by GrouperFormula.

export default class GrouperFormulaVisitor extends antlr4.tree.ParseTreeVisitor {

	// Visit a parse tree produced by GrouperFormula#root.
	visitRoot(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#FieldReference.
	visitFieldReference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#StringLiteral.
	visitStringLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#Brackets.
	visitBrackets(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#BooleanLiteral.
	visitBooleanLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#RightWhitespaceOrComments.
	visitRightWhitespaceOrComments(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#DecimalLiteral.
	visitDecimalLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#LeftWhitespaceOrComments.
	visitLeftWhitespaceOrComments(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#FunctionCall.
	visitFunctionCall(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#FieldByIdReference.
	visitFieldByIdReference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#LookupFieldReference.
	visitLookupFieldReference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#IntegerLiteral.
	visitIntegerLiteral(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#BinaryOp.
	visitBinaryOp(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#ws_or_comment.
	visitWs_or_comment(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#func_name.
	visitFunc_name(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#field_reference.
	visitField_reference(ctx) {
	  return this.visitChildren(ctx);
	}


	// Visit a parse tree produced by GrouperFormula#identifier.
	visitIdentifier(ctx) {
	  return this.visitChildren(ctx);
	}



}